import { render } from "./Default.vue?vue&type=template&id=b528c0c0"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__